import styled from "styled-components";

export const SidebarWrapper = styled.div`
    position: relative;
    .admin_sidebar_info {
        &_image {
            width: 100%;
            display: flex;
            justify-content: center;
            div{
                display: flex;
                justify-content: center;
                align-items: center;
                height: 100%;
                background-color: #333;
                border-radius: 50%;
            }
            .avatar {
                width: 100%;
                height: 100%;
                border-radius: 50%;
                object-fit: contain;
            }
        }
        &_name {
            width: 100%;
            display: flex;
            justify-content: center;
            div {
                span {
                    font-weight: 500;
                }
                p{
                    text-align: center;
                    margin: 0;
                }
            }
        }
    }
    .admin_sidebar_menu {
        list-style: none;
        .admin_sidebar_menu_item {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 22px;
            height: 50px;
            &:hover {
                background-color: #333;
                cursor: pointer;
            }
            i,
            span {
                color: #e9e9e9;
                font-size: 1.2rem;
            }
            span {
                margin-left: 12px;
            }
        }
        &_item-active {
            background-color: #333;
        }
    }
    .admin_sidebar_change-size{
        position: absolute;
        color: #fff;
        top: 10px;
        right: 10px;
        cursor: pointer;
        &:hover{
            color: #fb6e2e;
        }
    }
`
